"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectExpressionExtractor = void 0;
var ObjectExpressionExtractor;
(function (ObjectExpressionExtractor) {
    ObjectExpressionExtractor["BasePropertiesExtractor"] = "BasePropertiesExtractor";
    ObjectExpressionExtractor["ObjectExpressionToVariableDeclarationExtractor"] = "ObjectExpressionToVariableDeclarationExtractor";
})(ObjectExpressionExtractor || (exports.ObjectExpressionExtractor = ObjectExpressionExtractor = {}));
